module.exports = __webpack_public_path__ + "static/img/08032B_1_R_20200820_LC.86f95b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/08032B_1_R_20200820_LC.png
// module id = HW3o
// module chunks = 0